import type { SVGProps } from "react";

const SvgVolksbankKaerntenSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="-23.5 54.5 559.0 416.0"
    fill="none"
    {...props}
  >
    <path
      fill="#15569C"
      d="m305.525 96-47.68 186.718L207.811 96H18s2.062 12.956 4.87 22.992c2.799 10.046 6.81 20.571 6.81 20.571h118.326l5.596 17.911H37.722s5.585 11.522 13.554 23.594c7.959 12.062 14.415 19.969 14.415 19.969h101.486l5.441 17.485h-91.87s17.504 18.108 30.489 28.384c13.286 10.503 20.695 15.137 20.695 15.137h54.252L238.217 429h36.758l51.401-166.957h53.692s7.42-4.634 20.695-15.137c12.985-10.276 30.499-28.384 30.499-28.384h-91.486l5.378-17.485H446.33s6.435-7.907 14.394-19.969c7.969-12.072 13.565-23.594 13.565-23.594H358.574l5.524-17.911h118.223s4.01-10.525 6.819-20.571C491.938 108.956 494 96 494 96z"
    />
  </svg>
);
export default SvgVolksbankKaerntenSmallLogo;
